module.exports = __webpack_public_path__ + "static/media/checkmate.4315d6cd.png";